import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import { withStyles } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import JqxLoader from "jqwidgets-scripts/jqwidgets-react-tsx/jqxloader";
import JqxDateTimeInput from "jqwidgets-scripts/jqwidgets-react-tsx/jqxdatetimeinput";
import * as Util from "../../utils/util.js";
import BasicBackBoard from "../../components/BasicBackBoard.js";
import AutoCompleteInputTextField from "../../components/AutoCompleteInputTextField.js";

import PqGrid from "../../components/PqGrid.js";

const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "#ABADB3",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "green",
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "white !important",
      borderRadius: "2px",
      fontFamily: `"Malgun Gothic", "맑은 고딕", AppleSDGothicNeo-Light, sans-serif`,
      "& fieldset": { color: "#ABADB3" },
      "&.Mui-focused fieldset": {
        borderColor: "rgba(0, 176, 246, 1)",
      },
    },
    "& .MuiOutlinedInput-input": {
      fontSize: "13px",
      paddingLeft: "6px",
      paddingRight: "6px",
    },
    "& .MuiIconButton-root": {
      padding: "1px",
      margin: "0px 2px",
    },
  },
})(TextField);

const useStyles = makeStyles(() => ({
  root: { flex: 1, width: "100%", marginTop: "0px" },

  spanVerticalAlign: {
    lineHeight: "26px",
  },

  clearIcon: {
    position: "relative",
    float: "right",
    left: "-620px",
    zIndex: 2,
  },

  cellStyle: { border: "1px solid" },

  textField: {
    width: "200px",
  },

  numberTextField: {
    fontSize: "14px",
    width: "60px",
    height: "26px",
  },

  span: {
    display: "inline-block",
    fontFamily: `"Malgun Gothic", "\B9D1\C740 \ACE0\B515", AppleSDGothicNeo-Light, sans-serif`,
    color: "#4e545f",
    fontWeight: "bold",
    fontSize: "12px",
    lineHeight: "1.5em",
    paddingTop: "3px",
    whiteSpace: "nowrap",
    overflowX: "clip",
    marginLeft: "20px",
  },

  datePicker: {
    width: "165px",
    margin: 0,
    padding: 0,
    fontSize: "1px",
  },

  header: {
    width: "100%",
    marginTop: "10px",
    height: "50px",
    fontFamily: "NanumGothic",
  },

  footer: {
    position: "fixed",
    width: "100%",
    height: "35px",
    backgroundColor: "#DADADA",
    color: "white",
    bottom: 0,
  },
}));

function Menu9(props) {
  const classes = useStyles();
  const myLoader = useRef();
  const myCalendar = useRef();
  const [itemList, setItemList] = useState([]);
  const [itemList2, setItemList2] = useState([]);
  const [culture, setCulture] = useState("ko-KR");
  const refSearchSellCust = useRef();
  const refBalance = useRef();
  const refNonTax = useRef();
  const refTotAmount = useRef();
  const refPqGrid = useRef(null);
  const refPqGrid2 = useRef(null);
  const [onDisplay, setOnDisplay] = useState(false);
  const [title, setTitle] = useState("");

  useEffect(() => {
    if (props.name === props.selected) {
      setOnDisplay(true);
    } else {
      setOnDisplay(false);
    }
  }, [props.name, props.selected]);

  const [columnLayout, setColumnLayout] = useState([
    {
      title: "일자",
      dataIndx: "SLIP_DATE",
      width: 110,
      editable: false,
      styleHead: { "text-align": "center" },
      style: { "font-size": "14px", "text-align": "center" },
    },
    {
      title: "매출액",
      dataIndx: "DEB_AMOUNT",
      width: 110,
      editable: false,
      styleHead: { "text-align": "center" },
      style: { "font-size": "14px" },
      dataType: "float",
      format: "#,##0",
      summary: { type: "sum" },
    },
    {
      title: "수금금액",
      dataIndx: "CRE_AMOUNT",
      width: 110,
      editable: false,
      styleHead: { "text-align": "center" },
      style: { "font-size": "14px" },
      dataType: "float",
      format: "#,##0",
      summary: { type: "sum" },
    },
    {
      title: "잔액",
      dataIndx: "NOW_AMOUNT",
      width: 130,
      editable: false,
      styleHead: { "text-align": "center" },
      style: { "font-size": "14px" },
      dataType: "float",
      format: "#,##0",
    },
    {
      title: "비고",
      dataIndx: "REMARK",
      width: 200,
      editable: false,
      styleHead: { "text-align": "center" },
    },
  ]);

  const [columnLayout2, setColumnLayout2] = useState([
    {
      title: "출고일",
      dataIndx: "OUT_DATE",
      width: 110,
      editable: false,
      styleHead: { "text-align": "center" },
      style: { "font-size": "14px", "text-align": "center" },
    },
    {
      title: "품명",
      dataIndx: "NAME_NAME",
      width: 80,
      editable: false,
      styleHead: { "text-align": "center" },
    },
    {
      title: "재질",
      dataIndx: "STAN_NAME",
      width: 110,
      editable: false,
      styleHead: { "text-align": "center" },
    },
    {
      title: "SIZE",
      dataIndx: "SIZE_NO",
      width: 110,
      editable: false,
      styleHead: { "text-align": "center" },
    },
    // {
    //   title: "수량",
    //   dataIndx: "QUANITTY",
    //   width: 80,
    //   editable: false,
    //   styleHead: { "text-align": "center" },
    //   style: { "font-size": "14px" },
    //   dataType: "float",
    //   format: "#,##0",
    //   summary: { type: "sum" },
    // },
    {
      title: "중량",
      dataIndx: "WEIGHT",
      width: 110,
      editable: false,
      styleHead: { "text-align": "center" },
      style: { "font-size": "14px" },
      dataType: "float",
      format: "#,##0",
      summary: { type: "sum" },
    },
    {
      title: "금액",
      dataIndx: "SHIP_AMOUNT",
      width: 115,
      editable: false,
      styleHead: { "text-align": "center" },
      style: { "font-size": "14px" },
      dataType: "float",
      format: "#,##0",
      summary: { type: "sum" },
    },
    {
      title: "부가세",
      dataIndx: "TAX",
      width: 80,
      editable: false,
      styleHead: { "text-align": "center" },
      style: { "font-size": "14px" },
      dataType: "float",
      format: "#,##0",
      summary: { type: "sum" },
    },
    {
      title: "합계",
      dataIndx: "TOT_AMOUNT",
      width: 125,
      editable: false,
      styleHead: { "text-align": "center" },
      style: { "font-size": "14px" },
      dataType: "float",
      format: "#,##0",
      summary: { type: "sum" },
    },
  ]);

  const loadItem = (monthsOffset) => {
    if (!Util.isOutsider()) {
      if (refSearchSellCust.current.get().code == "") {
        alert("수요가 필수입니다");
        return;
      }
    }
    let dateT = new Date(
      myCalendar.current.getDate() - new Date().getTimezoneOffset() * 60000
    )
      .toISOString()
      .substring(0, 10)
      .replaceAll("-", "");
    let dateF = calculateDate(dateT, monthsOffset);

    myLoader.current.open();

    axios
      .get(Util.getBaseUrl() + "Menu9/retrieve", {
        params: {
          isOutSider: Util.isOutsider(),
          dateF: dateF,
          dateT: dateT,
          userId: window.sessionStorage.getItem("user_id"),
          myCustCd: window.sessionStorage.getItem("workplace_cd"),
          sellCustCd: refSearchSellCust.current.get().code,
          sellCustName: refSearchSellCust.current.get().input,
        },
      })
      .then((response) => {
        if (response.data.code === "0") {
          myLoader.current.close();
          let res = response.data;
          setItemList(res.balance);
          setItemList2(res.nonTax);
          let master = res.master;
          refBalance.current.set(master.BALANCE_AMOUNT);
          refNonTax.current.set(master.NON_TAX_AMOUNT);
          refTotAmount.current.set(master.TOT_AMOUNT);
          setTitle(`(${master.DATE_F} ~ ${master.DATE_T})`);
        } else {
          refBalance.current.set("");
          refNonTax.current.set("");
          refTotAmount.current.set("");
          alert(
            "조회된 내역이 없습니다.",
            myLoader.current.close(),
            setItemList([]),
            setItemList2([]),
            setTitle("")
          );
        }
      })
      .catch((e) => {
        console.error(e);
        alert(e.message);
        setItemList([]);
        setItemList2([]);
        setTitle("");
        refBalance.current.set("");
        refNonTax.current.set("");
        refTotAmount.current.set("");
        myLoader.current.close();
      });
  };

  const calculateDate = (baseDate, monthsOffset) => {
    const year = parseInt(baseDate.substring(0, 4), 10);
    const month = parseInt(baseDate.substring(4, 6), 10) - 1; // JavaScript의 month는 0부터 시작
    const day = parseInt(baseDate.substring(6, 8), 10);

    let date = new Date(year, month, day);

    if (monthsOffset === 0) {
      // 당월 초로 이동 (YYYYMM01)
      date.setDate(1);
    } else {
      // monthsOffset 만큼 월 이동
      date.setMonth(date.getMonth() - monthsOffset);

      // 조정된 월에 동일 일자 계산
      let adjustedDay = day;

      // 이동한 월의 일자보다 큰 경우, 마지막 날로 조정
      const lastDayOfMonth = new Date(
        date.getFullYear(),
        date.getMonth() + 1,
        0
      ).getDate();
      if (adjustedDay > lastDayOfMonth) {
        adjustedDay = lastDayOfMonth;
      }

      // 조정된 일자가 동일 일자 + 1이 되는 요구사항 처리
      date.setDate(adjustedDay + 1);
    }

    // 결과를 YYYYMMDD 형식으로 반환
    const resultYear = date.getFullYear();
    const resultMonth = String(date.getMonth() + 1).padStart(2, "0"); // 1-based month
    const resultDay = String(date.getDate()).padStart(2, "0");

    return `${resultYear}${resultMonth}${resultDay}`;
  };

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <div
        style={{
          display: "flex",
          height: "100%",
          flexDirection: "column",
          flex: 1,
        }}
      >
        <BasicBackBoard>
          <div className="d-flex p-1 search-form-div">
            <div>
              <span className={classes.span}>기준일</span>
            </div>
            <div className="ms-2" onKeyDown={Util.enterToFocusMove}>
              <JqxDateTimeInput
                textAlign="center"
                ref={myCalendar}
                animationType={"none"}
                formatString={"yyyy-MM-dd"}
                culture={culture}
                width={130}
                height={"26px"}
              />
            </div>
            <div
              style={{
                display: "flex",
                visibility: Util.isOutsider() ? "hidden" : "visible",
              }}
            >
              <div>
                <span className={classes.span}>수요가 </span>
              </div>
              <div className="ms-2">
                <AutoCompleteInputTextField
                  ref={refSearchSellCust}
                  placeholder={"필수입력"}
                  lists={JSON.parse(
                    window.sessionStorage.getItem("sellCustCd")
                  )}
                />
              </div>
            </div>
            <Button
              className="d-btn primary"
              onClick={() => loadItem(0)}
              style={{
                marginLeft: "10px",
              }}
              variant="contained"
            >
              당월
            </Button>
            <Button
              className="d-btn primary"
              onClick={() => loadItem(3)}
              variant="contained"
              style={{
                marginLeft: "6px",
              }}
            >
              3개월
            </Button>
            <Button
              className="d-btn primary"
              onClick={() => loadItem(6)}
              variant="contained"
              style={{
                marginLeft: "6px",
              }}
            >
              6개월
            </Button>
            <Button
              className="d-btn primary"
              onClick={() => loadItem(9)}
              variant="contained"
              style={{
                marginLeft: "6px",
              }}
            >
              9개월
            </Button>
            <Button
              className="d-btn primary"
              onClick={() => loadItem(12)}
              variant="contained"
              style={{
                marginLeft: "6px",
              }}
            >
              12개월
            </Button>
          </div>
          <div
            className="d-flex mt-3 pt-4"
            style={{
              justifyContent: "space-evenly",
              borderTop: "1px solid rgba(183, 183, 183, 0.617)",
            }}
          >
            <div className="d-flex" style={{ alignItems: "center" }}>
              <div>청구잔액</div>
              <div style={{ marginLeft: "4px" }}>
                <AutoCompleteInputTextField
                  ref={refBalance}
                  lists={[]}
                  width={170}
                  readOnly
                  textAlign={"right"}
                />
              </div>
            </div>
            <div className="d-flex" style={{ alignItems: "center" }}>
              <div>미청구잔액</div>
              <div style={{ marginLeft: "4px" }}>
                <AutoCompleteInputTextField
                  ref={refNonTax}
                  lists={[]}
                  width={170}
                  readOnly
                  textAlign={"right"}
                />
              </div>
            </div>
            <div
              className="d-flex"
              style={{ alignItems: "center", marginRight: "80px" }}
            >
              <div>합계</div>
              <div style={{ marginLeft: "4px" }}>
                <AutoCompleteInputTextField
                  ref={refTotAmount}
                  lists={[]}
                  width={170}
                  readOnly
                  textAlign={"right"}
                />
              </div>
            </div>
          </div>
        </BasicBackBoard>

        <div className={classes.root}>
          <div
            style={{
              display: "flex",
              height: "100%",
              borderTop: "1px solid rgba(183, 183, 183, 0.617)",
            }}
          >
            <div
              style={{
                flex: "0.8",
                backgroundColor: "white",
                display: "flex",
                flexDirection: "column",
                borderRight: "1px solid rgba(183, 183, 183, 0.617)",
              }}
            >
              <div className="p-4">청구현황 {title}</div>
              <div style={{ flex: 1 }}>
                <PqGrid
                  name={props.name}
                  ref={refPqGrid}
                  width={"100%"}
                  columns={columnLayout}
                  dataModel={itemList}
                  display={onDisplay}
                />
              </div>
            </div>
            <div
              style={{
                flex: "1.2",
                backgroundColor: "white",
                display: "flex",
                flexDirection: "column",
                paddingLeft: "2px",
              }}
            >
              <div className="p-4">미청구현황 {title}</div>
              <div style={{ flex: 1 }}>
                <PqGrid
                  ref={refPqGrid2}
                  width={"100%"}
                  columns={columnLayout2}
                  dataModel={itemList2}
                  display={onDisplay}
                />
              </div>
            </div>
          </div>
          <JqxLoader ref={myLoader} width={100} height={60} />
        </div>
      </div>
    </div>
  );
}

export default React.memo(Menu9);
